import { useEffect, useState } from "react";

type ProgressBarProps = {
  currentPage: number;
  totalPages: number;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentPage,
  totalPages,
}) => {
  const [progress, setProgress] = useState<number[]>(Array(totalPages).fill(0));

  useEffect(() => {
    let tempProgress = [...progress];

    tempProgress = tempProgress.map((item, idx) => {
      if (idx <= currentPage - 1) {
        return 1;
      } else {
        return 0;
      }
    });

    setProgress(tempProgress);
  }, []);

  return (
    <div className="ProgressBar">
      {progress &&
        progress.map((item: number, idx) => {
          return (
            <div
              className={`ProgressItem ${item === 1 ? "Complete" : ""}`}
              key={`progress-item-${idx}`}
            ></div>
          );
        })}
    </div>
  );
};

export default ProgressBar;
